import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { UISharedModule } from '../ui-shared/ui-shared.module'
import { AdminComponent } from './admin.component'
import { AdminRoutingModule } from './admin-routing.module'
import { AdminGuard } from './admin-guard.service';
import { UsersComponent } from './users/users.component'

@NgModule({
	imports: [
		CommonModule,
		AdminRoutingModule,
		UISharedModule,
	],
	declarations: [
		AdminComponent,
		UsersComponent,
	],
	providers: [
		AdminGuard,
	]
})

export class AdminModule { }



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/admin.module.ts